export var createMuiTypographyOverrides = function (_a // eslint-disable-line @typescript-eslint/no-unused-vars
) {
    var typography = _a.typography;
    return ({
        gutterBottom: {
            // `body1` gutter as default
            marginBottom: typography.pxToEm(20, 14),
            "&$h1": { marginBottom: typography.pxToEm(40, 40) },
            "&$h2": { marginBottom: typography.pxToEm(20, 30) },
            "&$h3": { marginBottom: typography.pxToEm(20, 22) },
            "&$h4": { marginBottom: typography.pxToEm(20, 18) },
            "&$h5": { marginBottom: typography.pxToEm(20, 18) },
            "&$body1, &$body2": { marginBottom: typography.pxToEm(20, 14) },
            "&$caption": { marginBottom: typography.pxToEm(10, 12) },
            "&$button": { marginBottom: typography.pxToEm(10, 12) },
            "&$overline": { marginBottom: typography.pxToEm(10, 9) },
        },
    });
};
//# sourceMappingURL=MuiTypography.js.map